import { useCallback, useEffect, useState, useRef } from "react";
import { MccApi } from "lib/api/mccApiWrapper";
import { SectorAdminContactInfo } from "models/dto/user";
import { UsePermissionRefresh } from "./useSectorsAndPermissions";

export function UseSectorAdminContactInfo() {
	const [contactInfo, setContactInfo] = useState<SectorAdminContactInfo[]>([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState("");
	const fetchingRef = useRef(false);

	const { handlePermissionError } = UsePermissionRefresh();

	const fetchContactInfo = useCallback(async () => {
		
		// Prevent duplicate calls (especially useful in React StrictMode)
		if (fetchingRef.current) {
			return;
		}

		try {
			fetchingRef.current = true;
			setLoading(true);
			setError("");

			const api = MccApi.GetInstance((window as any).store);
			const resp = await api.FindSectorAdminContactInfo();
			setContactInfo(resp);
		} catch (e: any) {
			try {
				await handlePermissionError(e);
			} catch (retryError: any) {
				setError(
					retryError?.response?.data?.message ||
						retryError?.message ||
						"Failed to load sector admin contact information."
				);
				setContactInfo([]);
			}
		} finally {
			setLoading(false);
			fetchingRef.current = false;
		}
	}, [handlePermissionError]);

	// Fetch all contact info once on mount
	useEffect(() => {
		fetchContactInfo();
	}, [fetchContactInfo]);

	return { contactInfo, loading, error };
}

